var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoTrainKtxH16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 16,
  viewBox: "0 0 40 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#013691",
  d: "M10.681 2.329 5.676 5.758l.552-.75.788-2.68H3.192L0 13.01h3.778l1.267-3.98.512-.356 1.695 4.336h3.823L8.75 6.697l3.113-2.082 3.154.04-2.404 8.355h3.822l2.405-8.316h3.626l3.783 8.316h3.823L26.84 5.718l-1.793.48 1.242-1.623-.985-2.246z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C11740",
  d: "M18.523 13.01h3.903S30.151 1.698 39.73.082c0 0-11.747-.236-21.206 12.928"
}))));
export default SvgLogoTrainKtxH16;